import PropTypes from 'prop-types'

const Details = ({ label, value, className, children }) => {
  return (
    <div className={`visitor-details__section-item ${className || ''}`}>
      <span>{label}</span>
      {children || <p>{value || '---'}</p>}
    </div>
  )
}

Details.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  children: PropTypes.element,
}

export default Details
